var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPin16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22189 2.00002L1.97925 6.24266L2.68635 6.94976C3.07688 7.34028 3.71005 7.34028 4.10057 6.94976L6.92899 9.77818C6.14795 10.5592 6.14795 11.8256 6.929 12.6066L9.05032 10.4853L12.5859 14.0208L14.0001 14.0208L14.0001 12.6066L10.4645 9.07106L12.5859 6.94975C11.8048 6.16872 10.5385 6.16866 9.75742 6.94966L6.92905 4.12128C7.31954 3.73079 7.31954 3.09767 6.92905 2.70717L6.22189 2.00002Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;